import { SituacaoUpload, TipoDocumentoTurmaCertificacao } from 'src/tipos'

import { UploadDocumentos } from '../tipos'

export const RelacaoDocumentosTurmaCertificacao = new Array<UploadDocumentos>({
  id: 1,
  tipo: TipoDocumentoTurmaCertificacao.PPC,
  status: SituacaoUpload.PendenteEnvio,
  ordemExibicao: 1,
  obrigatorio: true,
  editarAprovado: true
} as UploadDocumentos)
